import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import MainLayout from "../components/Layout/MainLayout";
import BonusLog from "../pages/BonusLog";
import AutoTrade from "../pages/AutoTrade";
import Dashboard from "../pages/Dashboard";
import AffiliateDetails from "../pages/AffiliateDetails";
import GlobalBonus from "../pages/GlobalBonus";
import LevelBonus from "../pages/LevelBonus";
import LevelBusinessChart from "../pages/LevelBusinessChart";
import MyAllAffiliate from "../pages/MyAllAffiliate";
import MyReferralList from "../pages/MyReferralList";
import ReferralBonus from "../pages/ReferralBonus";
import NFTMarketPlace from "../pages/NFTMarketPlace"; 
import NFTDetails from "../pages/NFTDetails"; 
import MyNFTDetails from "../pages/MyNFTDetails"; 
import SellNft from "../pages/SellNft"; 
import LeaderBoard from "../pages/LeaderBoard"; 
import LeaderBonus from "../pages/LeaderBonus"; 
import NftLevelBonus from "../pages/NftLevelBonus";
import NftTradingHistory from "../pages/NftTradingHistory"; 
import CTOUser from "../pages/CTOUser"; 
import ReserveReport from "../pages/ReserveReport"; 
import MyNFTTradehistory from "../pages/MyNFTTradehistory";
import NFT24HList from "../pages/NFT24HList";
import MultipleNFTBuy from "../pages/MultipleNFTBuy";
import Revesefundshistory from "../pages/Revesefundshistory"; 
import Adminfetch from "../pages/Adminfetch"; 
import AllNFTdetails from "../pages/AllNFTdetails"; 
import NftBuyOwner from "../pages/NftBuyOwner"; 
import NftBuyOwnerSearch from "../pages/NftBuyOwnerSearch"; 
import DepositTradingFunds from "../pages/DepositTradingFunds"; 
import AllTradeWallet from "../pages/AllTradeWallet"; 




const CurrentPath = () => {
  const location = useLocation();
  useEffect(() => {
    document.title = "iBullz";
  }, [location]);
  return null;
};

const Router = () => {
  return (
    <BrowserRouter>
      <CurrentPath />
      <Routes>
        <Route
          path="/"
          element={
              <MainLayout>
                <Dashboard />
              </MainLayout>
          }
        />


        <Route
          path="/affiliate-details"
          element={
              <MainLayout>
                <AffiliateDetails />
              </MainLayout>
          }
        />



        <Route
          path="/nft-market-place"
          element={
              <MainLayout>
                <NFTMarketPlace />
              </MainLayout>
          }
        />

         <Route
          path="/my-nft-history"
          element={
              <MainLayout>
                <MyNFTDetails />
              </MainLayout>
          }
        />

        <Route
          path="/all-nft-details-price"
          element={
              <MainLayout>
                <AllNFTdetails/>
              </MainLayout>
          }
        />

        <Route
          path="/NFT-details"
          element={
              <MainLayout>
                <NFTDetails />
              </MainLayout>
       }
        />

        <Route
          path="/monthly-trading-history"
          element={
              <MainLayout>
                <NftTradingHistory />
              </MainLayout>
       }
        />

        <Route
          path="/on-sale"
          element={
              <MainLayout>
                <SellNft/>
              </MainLayout>
        }
        />

         <Route
          path="/Nft-leader-Bonus"
          element={
              <MainLayout>
                <LeaderBonus/>
              </MainLayout>
        }
        />

         <Route
          path="/top-10-leaderboard"
          element={
              <MainLayout>
                <LeaderBoard/>
              </MainLayout>
        }
        />

        <Route
          path="/all-bonus-log"
          element={
              <MainLayout>
                <BonusLog />
              </MainLayout>
          }
        />

         <Route
          path="/all-royalty-users"
          element={
              <MainLayout>
                <CTOUser />
              </MainLayout>
          }
        />

         <Route
          path="/adm0F7in26-coA4mpanb0Ay-de485tail73s"
          element={
              <MainLayout>
                <Adminfetch />
              </MainLayout>
          }
        />


         <Route
          path="/adm0F7in26-coA4mpanb0Ay-de485tail73s-only-owner"
          element={
              <MainLayout>
                <NftBuyOwner />
              </MainLayout>
          }
        />

         <Route
          path="/nft-search-adm0F7in26-coA4mpanb0Ay-de485tail73s-only-owner"
          element={
              <MainLayout>
                <NftBuyOwnerSearch />
              </MainLayout>
          }
        />

        <Route
          path="/deposit-trading-funds"
          element={
              <MainLayout>
                <DepositTradingFunds />
              </MainLayout>
          }
        />

        <Route
          path="/all-trade-user-check"
          element={
              <MainLayout>
                <AllTradeWallet />
              </MainLayout>
          }
        />
        
        

        {/* <Route
          path="/reserve-log"
          element={
              <MainLayout>
                <ReserveReport />
              </MainLayout>
          }
        /> */}


        <Route
          path="/auto-trade-adm0F7in26-coA4mpanb0Ayownersssses"
          element={
              <MainLayout>
                <AutoTrade />
              </MainLayout>
          }
        />

        <Route
          path="/royalty-bonus"
          element={
              <MainLayout>
                <GlobalBonus />
              </MainLayout>
          }
        />

        <Route
          path="/level-bonus"
          element={
              <MainLayout>
                <LevelBonus />
              </MainLayout>
          }
        />

        <Route
          path="/nft-trade-history"
          element={
              <MainLayout>
                <MyNFTTradehistory />
              </MainLayout>
          }
        />

         <Route
          path="/multiple-nfttrade-buy-group-onlyowner-s"
          element={
              <MainLayout>
                <MultipleNFTBuy />
              </MainLayout>
          }
        />

        <Route
          path="/nft-24h-list"
          element={
              <MainLayout>
                <NFT24HList />
              </MainLayout>
          }
        />

        <Route
          path="/my-all-affiliate"
          element={
              <MainLayout>
                <MyAllAffiliate />
              </MainLayout>
          }
        />

        <Route
          path="/my-referral-list"
          element={
              <MainLayout>
                <MyReferralList />
              </MainLayout>
          }
        />

          <Route
          path="/my-nft-allLevel-bonus"
          element={
              <MainLayout>
                <NftLevelBonus/>
              </MainLayout>
          }
        />

          <Route
          path="/reserve-withdraw-history"
          element={
              <MainLayout>
                <Revesefundshistory/>
              </MainLayout>
          }
        />

        <Route
          path="/referral-bonus"
          element={
              <MainLayout>
                <ReferralBonus />
              </MainLayout>
          }
          
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
